import { render, staticRenderFns } from "./PageNoData.vue?vue&type=template&id=743bc259&"
import script from "./PageNoData.vue?vue&type=script&lang=js&"
export * from "./PageNoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports